import { Validator } from 'vee-validate';

Validator.extend('usdt_address', {
	getMessage: field => `The ${field} is not a valid USDT address.`,
	validate: value => {
		const ethAddressRegex = /^0x[a-fA-F0-9]{40}$/;
		const trxAddressRegex = /^T[a-zA-Z0-9]{33}$/;
		return ethAddressRegex.test(value) || trxAddressRegex.test(value);
	}
});
